import { render, staticRenderFns } from "./TableDataBatchDeleted.vue?vue&type=template&id=af28c0d0"
import script from "./TableDataBatchDeleted.vue?vue&type=script&lang=js"
export * from "./TableDataBatchDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports